import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Right from "./Right";
import { server } from "../../server";
import { useDispatch } from "react-redux";
import { fetchProfileById } from "../../redux/profileSlice";
import { getUserIdFromToken } from "../../utils/auth";

function Notifications() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);
  const [profiles, setProfiles] = useState({});
  const [loading, setLoading] = useState(true);

  /* ---------- helpers ---------- */
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}/${month}/${year} ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  /* ---------- fetch notifications ---------- */

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const userId = getUserIdFromToken();

        const res = await fetch(
          `${server}/notification/GetNotificationsByUserId?userId=${userId}`,
          {
            headers: { Authorization: token },
          }
        );

        const data = await res.json();

        const sorted = (data || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setNotifications(sorted);

        // fetch sender profiles
        const profileResults = await Promise.all(
          sorted.map((n) => dispatch(fetchProfileById(n.fromUserId)))
        );

        const map = {};
        sorted.forEach((n, i) => {
          map[n.fromUserId] = profileResults[i]?.payload || {};
        });

        setProfiles(map);
      } catch (err) {
        console.error("Failed to fetch notifications", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [dispatch]);

  /* ---------- UI ---------- */

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <Link
                  onClick={() => navigate(-1)}
                  className="icon-shape me-3 icon-lg bg-light-red rounded-circle"
                >
                  <i className="bi bi-chevron-left fs-3 text-primary"></i>
                </Link>
                <div>
                  <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                    Notifications
                  </h3>
                  <p className="lh-sm fw-normal m-0">
                    Alert from matches / profiles for you
                  </p>
                </div>
              </div>

              {/* Content */}
              <div className="bg-white rounded-4 p-4">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-danger"></div>
                  </div>
                ) : notifications.length === 0 ? (
                  <p className="text-center text-muted m-0">
                    No notifications yet.
                  </p>
                ) : (
                  notifications.map((item, index) => {
                    const profile = profiles[item.fromUserId] || {};
                    const imageUrl =
                      profile?.images?.[0]?.docUrl ||
                      "/assets/images/profile-default.jpg";

                    return (
                      <div key={index} className="d-flex align-items-center">
                        <img
                          src={imageUrl}
                          className="object-fit-cover rounded-circle"
                          width="50"
                          height="50"
                          alt="Profile"
                        />
                        <div className="ms-3">
                          <h4 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                            {item?.content} — {profile?.name}
                          </h4>
                          <p className="d-flex align-items-center m-0 lh-1 text-secondary">
                            {item?.title}
                          </p>
                          <p className="d-flex align-items-center m-0 lh-1">
                            {formatDateTime(item?.createdAt)}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default Notifications;
